import { MasterCrudPage } from '@/components/MasterCrudPage.jsx';

export default function DesignationsPage() {
  return (
    <MasterCrudPage
      title="Designations"
      description="Job titles / positions"
      endpoint="/designations"
      queryKey={['designations']}
      fields={[
        { name: 'code', label: 'Code', required: true },
        { name: 'name', label: 'Name', required: true },
        { name: 'description', label: 'Description', type: 'textarea' },
      ]}
      columns={[
        { key: 'code', header: 'Code', sortable: true, className: 'font-mono' },
        { key: 'name', header: 'Name', sortable: true },
        { key: 'description', header: 'Description' },
      ]}
    />
  );
}
